import styled from 'styled-components'

const Section = styled.div`
  background: white;
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  padding: ${({ theme }) => theme.spacing.lg};
`

const SectionTitle = styled.h3`
  margin: 0 0 ${({ theme }) => theme.spacing.xs} 0;
  font-size: ${({ theme }) => theme.fontSizes.md};
  color: ${({ theme }) => theme.colors.primary};
`

const Subtitle = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ theme }) => theme.colors.textMuted};
  margin: 0 0 ${({ theme }) => theme.spacing.md} 0;
`

const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.75rem;
`

interface CardProps {
    bgGradient: string
    fullWidth?: boolean
}

const Card = styled.div<CardProps>`
  padding: ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.borderRadius.lg};
  text-align: center;
  color: white;
  cursor: pointer;
  transition: transform ${({ theme }) => theme.transitions.normal},
              box-shadow ${({ theme }) => theme.transitions.normal};
  background: ${({ bgGradient }) => bgGradient};
  ${({ fullWidth }) => fullWidth && 'grid-column: 1 / -1;'}

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
  }
`

const CardValue = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xxl};
  font-weight: 700;
`

const CardLabel = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.sm};
  margin-top: ${({ theme }) => theme.spacing.xs};
`

const CardSublabel = styled.div`
  font-size: ${({ theme }) => theme.fontSizes.xs};
  opacity: 0.85;
`

interface AvailabilitySectionProps {
    availability: {
        sinCarga: number
        bajaCarga: number
        mediaCarga: number
        altaCarga: number
    }
    onCardClick: (type: string) => void
}

export const AvailabilitySection: React.FC<AvailabilitySectionProps> = ({
    availability,
    onCardClick,
}) => {
    return (
        <Section>
            <SectionTitle>👥 Disponibilidad del Equipo a día de hoy</SectionTitle>
            <Subtitle>Clic para ver personas en cada categoría</Subtitle>
            <CardsGrid>
                <Card
                    bgGradient="linear-gradient(135deg, #C62828, #E53935)"
                    fullWidth
                    onClick={() => onCardClick('sin_carga')}
                >
                    <CardValue>{availability.sinCarga}</CardValue>
                    <CardLabel>Personas sin cargabilidad</CardLabel>
                    <CardSublabel>0% carga actual</CardSublabel>
                </Card>
                <Card
                    bgGradient="linear-gradient(135deg, #E65100, #F57C00)"
                    onClick={() => onCardClick('baja_carga')}
                >
                    <CardValue>{availability.bajaCarga}</CardValue>
                    <CardLabel>Baja carga</CardLabel>
                    <CardSublabel>1-50% carga</CardSublabel>
                </Card>
                <Card
                    bgGradient="linear-gradient(135deg, #F9A825, #FBC02D)"
                    onClick={() => onCardClick('media_carga')}
                >
                    <CardValue>{availability.mediaCarga}</CardValue>
                    <CardLabel>Media carga</CardLabel>
                    <CardSublabel>51-80% carga</CardSublabel>
                </Card>
                <Card
                    bgGradient="linear-gradient(135deg, #2E7D32, #43A047)"
                    onClick={() => onCardClick('alta_carga')}
                >
                    <CardValue>{availability.altaCarga}</CardValue>
                    <CardLabel>Alta carga</CardLabel>
                    <CardSublabel>&gt; 80% carga</CardSublabel>
                </Card>
            </CardsGrid>
        </Section>
    )
}
